import type { AreaCatalog } from '../area';
import type { plans as en } from '../en/plans';

export const plans = {
  // --- The Plans index ---
  'plans.index.title': 'Pläne',
  'plans.index.empty': 'Noch keine Pläne. Erstelle einen, um Änderungen vorzumerken.',
  'plans.sort.recent': 'Zuletzt hinzugefügt',
  'plans.sort.name': 'Name (A–Z)',
  'plans.sort.status': 'Status',
  'plans.sort.menu': 'Sortieren nach',
  'plans.sort.label': 'Pläne sortieren',
  'plans.status.planning': 'in Planung',
  'plans.status.executed': 'ausgeführt',
  'plans.badge.mine': 'eigener',
  // --- Create a plan ---
  'plans.create.justMe': 'Nur ich',
  'plans.create.placeholder': 'Name des neuen Plans',
  'plans.create.name': 'Name des Plans',
  'plans.create.audience': 'Personenkreis',
  'plans.create.submit': 'Plan erstellen',
  // --- A plan's page ---
  'plans.detail.staged': 'Vorgemerkte Änderungen',
  'plans.detail.empty':
    'Noch nichts vorgemerkt. Öffne eine Aufgabe und merke eine Änderung für diesen Plan vor.',
  'plans.change.applied': 'übernommen',
  'plans.change.staged': 'vorgemerkt',
  'plans.change.raised': 'vorgeschlagen',
  'plans.change.declined': 'abgelehnt',
  'plans.change.superseded': 'ersetzt',
  'plans.detail.ownerOnly': 'Nur wer den Plan verwaltet, kann ihn ausführen.',
  'plans.execute.submit': 'Plan ausführen',
  'plans.execute.result': {
    one: '{applied} direkt übernommen, {count} als Vorschlag eingereicht',
    other: '{applied} direkt übernommen, {count} als Vorschläge eingereicht',
  },
  'plans.error.groupNeeded': 'Ein neuer Plan braucht eine Gruppe.',
} as const satisfies AreaCatalog<typeof en>;
